import styled from 'styled-components';
import { ArrowDropDownIcon } from '@root/styles/icons';
import { media } from 'styled-bootstrap-grid';
import { HighlightSelected } from '../HighlightSelected';

export const OptionRow = styled(HighlightSelected)<{ requireTimeSlots: boolean }>`
  display: flex;
  padding: 24px 24px;
  ${({ requireTimeSlots }) => (requireTimeSlots ? 'padding-bottom: 0' : '')};
  border: 1px solid ${({ theme }) => theme.customColors.borderGreyLighter};
  border-radius: 3px;
  margin-top: 16px;
  align-items: ${({ requireTimeSlots }) => (requireTimeSlots ? 'flex-start' : 'center')};
  justify-content: space-between;
`;

export const OptionTitleStyle = styled.label`
  margin: 0px;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  word-wrap: break-word;
  line-height: 1.5em;
  padding-right: 24px;

  ${media.xs`
    line-height: 1.6em;
  `}

  ${media.md`
    margin: 10px 0 20px 0;
    width: 60%;
  `}
`;

export const RightAlignedDiv = styled.div<{ requireTimeSlots: boolean }>`
  width: 40%;
  > button {
    width: 100%;
    ${media.md`
      width: 50%;
    `}
    margin-bottom: ${({ requireTimeSlots }) => (requireTimeSlots ? '10px' : '0')};
    margin-right: 0;
    margin-left: auto;
  }
`;

export const CaretDownIcon = styled(ArrowDropDownIcon)`
  cursor: pointer;
  width: 10px;
  height: 10px;
  margin: 8px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  display: flex;
  transition: color 150ms;
  box-sizing: border-box;
`;
